"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StrategyMatrixSkeleton = exports.StrategyMatrixGridSkeleton = exports.default = void 0;
var strategy_matrix_skeleton_component_1 = require("./strategy-matrix-skeleton.component");
Object.defineProperty(exports, "default", { enumerable: true, get: function () { return __importDefault(strategy_matrix_skeleton_component_1).default; } });
Object.defineProperty(exports, "StrategyMatrixGridSkeleton", { enumerable: true, get: function () { return strategy_matrix_skeleton_component_1.StrategyMatrixGridSkeleton; } });
Object.defineProperty(exports, "StrategyMatrixSkeleton", { enumerable: true, get: function () { return strategy_matrix_skeleton_component_1.StrategyMatrixSkeleton; } });
